import React from 'react';

import { typography } from '@pray/shared/components/foundations';
import Text from '@pray/shared/components/ui/Text';
import { cn } from '@pray/shared/utils/styles';

import { amountTiers, amountTypes, donationIntervals } from '../../../constants';
import DonationFrequency from '../../../DonationFrequency/DonationFrequency';
import type { DonationForm, Fund } from '../../../types';

import styles from './DonationInterval.module.scss';

interface DonationIntervalProps {
  form: DonationForm;
  fund: Fund;
  onIntervalChange?: (interval: 'month' | 'year') => void;
}

export default function DonationInterval({ form, fund, onIntervalChange }: DonationIntervalProps) {
  function handleIntervalChange(interval: 'month' | 'year') {
    onIntervalChange?.(interval);
    form.setValue('interval', interval);

    if (form.values.amountType === amountTypes.custom) {
      return;
    }

    const isTier1Selected = amountTiers.tier1.value === form.values.amountTier;

    if (interval === donationIntervals.month) {
      const amount = isTier1Selected ? fund.default_amount_monthly : fund.amount_monthly_2;
      form.setValue('amount', amount);
    }

    if (interval === donationIntervals.year) {
      const amount = isTier1Selected ? fund.default_amount_yearly : fund.amount_yearly_2;
      form.setValue('amount', amount);
    }
  }

  return (
    <div className={cn(styles.frequencyContainer)}>
      <Text className={styles.frequencyTitle} variant={typography.heading_lg}>
        I want to give
      </Text>
      <div className={styles.frequencies}>
        <DonationFrequency
          interval={donationIntervals.month}
          value={form.values.interval}
          onChange={handleIntervalChange}
        />
        <DonationFrequency
          interval={donationIntervals.year}
          value={form.values.interval}
          onChange={handleIntervalChange}
        />
      </div>
    </div>
  );
}
